import { render, staticRenderFns } from "./AdvPageManage.vue?vue&type=template&id=69dacec8&scoped=true&"
import script from "./AdvPageManage.vue?vue&type=script&lang=js&"
export * from "./AdvPageManage.vue?vue&type=script&lang=js&"
import style0 from "./AdvPageManage.vue?vue&type=style&index=0&id=69dacec8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69dacec8",
  null
  
)

export default component.exports